// Adapted from hotels-website flexible date pricing (code in hotels-website is now removed)
import uniq from 'lodash/uniq';

import { priceBandConstants } from '../constants/priceBandConstants';

import quantileCalculator from './quantileCalculator';

import type {
  HotelPriceData,
  RawHotelDatePricesResponse,
} from '../../actions/types/dataTypes';

type QuartileValues = {
  cheapLimit: number;
  moderateLimit: number;
};

const classifyHotelsDatePrices = (
  rawResponse: RawHotelDatePricesResponse | null,
) => {
  const { indicativePrices } = rawResponse || {};

  if (!indicativePrices || !indicativePrices.length) {
    return {};
  }

  const priceDirection = (
    medianPrice: number | null,
    quartileValues: QuartileValues,
  ) => {
    if (medianPrice !== null) {
      if (medianPrice <= quartileValues.cheapLimit) {
        return priceBandConstants.HOTEL_PRICE_DIRECTION_CHEAP;
      }

      if (medianPrice <= quartileValues.moderateLimit) {
        return priceBandConstants.HOTEL_PRICE_DIRECTION_MODERATE;
      }

      return priceBandConstants.HOTEL_PRICE_DIRECTION_EXPENSIVE;
    }

    return null;
  };

  const sortedUniqueMedians = uniq(
    indicativePrices
      .filter(({ medianPrice }) => medianPrice !== null)
      .map(({ medianPrice }) => Number(medianPrice)), // keeping TS happy for sort as its not aware of filtering out nulls
  ).sort((a, b) => a - b);

  const priceBandConstantsArr = [...priceBandConstants.PRICE_BAND_BOUNDARIES];

  const quartiles = quantileCalculator(
    sortedUniqueMedians,
    priceBandConstantsArr,
  );

  const quartileValues = {
    cheapLimit: quartiles[0].value,
    moderateLimit: quartiles[1].value,
  };

  const flexibleDates: HotelPriceData = {};

  indicativePrices.forEach(({ date, medianPrice }) => {
    flexibleDates[date] = {
      direction: priceDirection(medianPrice, quartileValues),
      medianPrice,
    };
  });

  return flexibleDates;
};

export default classifyHotelsDatePrices;
